import { namedUnknown } from "./filter";

export interface clientsProps extends namedUnknown {
  name: string;
  Category: string;
  Domain: string;
  Testimonial: string;
  startYear: string;
}
export const clientsData: clientsProps[] = [
  {
    name: "ABC Corporation",
    Category: "Commercial Real Estate",
    Domain: "Luxury Home Development",
    Testimonial:
      "Estatein's expertise in finding the perfect office space for our expanding operations was invaluable. They truly understand our business needs.",
    startYear: "2019",
  },
  {
    name: "XYZ Group",
    Category: "Residential Real Estate",
    Domain: "Luxury Home Development",
    Testimonial:
      "Estatein's expertise in finding the perfect office space for our expanding operations was invaluable. They truly understand our business needs.",
    startYear: "2019",
  },
  {
    name: "PQR Corporation",
    Category: "Commercial Real Estate",
    Domain: "Luxury Home Development",
    Testimonial:
      "Estatein's expertise in finding the perfect office space for our expanding operations was invaluable. They truly understand our business needs.",
    startYear: "2019",
  },
  {
    name: "LMN Group",
    Category: "Residential Real Estate",
    Domain: "Luxury Home Development",
    Testimonial:
      "Estatein's expertise in finding the perfect office space for our expanding operations was invaluable. They truly understand our business needs.",
    startYear: "2019",
  },
  {
    name: "GreenTech Enterprises",
    Category: "Retail Space",
    Domain: "Commercial Real Estate",
    Testimonial:
      "Estatein's ability to identify prime retail locations helped us expand our brand presence. They are a trusted partner in our growth.",
    startYear: "2018",
  },
];
